module.exports = __webpack_public_path__ + "static/media/knife.4929aecc.png";